import { render, staticRenderFns } from "./MyMessage.vue?vue&type=template&id=4ffc1eac&scoped=true"
import script from "./MyMessage.vue?vue&type=script&lang=js"
export * from "./MyMessage.vue?vue&type=script&lang=js"
import style0 from "./MyMessage.vue?vue&type=style&index=0&id=4ffc1eac&prod&lang=scss"
import style1 from "./MyMessage.vue?vue&type=style&index=1&id=4ffc1eac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffc1eac",
  null
  
)

export default component.exports